import ReactPlayer from "react-player";
import React, { useState, useEffect, useContext } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import classnames from "classnames";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import InfoOutlined from "@material-ui/icons/InfoOutlined";

import { parseYTUrl } from "utils/urlUtils";
import { WebpageCreationContext } from "../../../..";
import {
  MODAL_TYPES,
  TESTIMONIAL_TYPES,
  TESTIMONIAL_ICON_MAP,
  TestimonialConfig,
  SHOW_CONTENT_LENGTH,
  SIDEBAR_SECTIONS,
  SIDEBAR_KEYS,
  SECTIONKEY_TO_MISC_KEY,
} from "../../../../constants";
import api from "../../../../../../../data/APIs";

import style from "./style.module.css";
import baseStyle from "../../style.module.css";
import { TextFields } from "../Unlock/Testimonials/TextFields";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import { is_empty } from "utils/validations";

import { creator_miscellaneous_data_types } from "features/Common/modules/CreatorData/CreatorData.constants";
import SectionVisibilityToggle from "../hideShow";
import { handleVisibilityToggle } from "../../utils";
import useVisibilityMutations from "../../useVisibilityMutations.hook";

const TestimonialItem = (props) => {
  const {
    item,
    isDragging,
    innerRef,
    children,
    disableAllEdits,
    handleEdit,
    handleDelete,
    ...rest
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    if (disableAllEdits) return;
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={style.testimonialCardOuter} ref={innerRef} {...rest}>
      <div
        className={`${style.testimonialCard} ${
          isDragging ? style.dragging : ""
        }`}
      >
        <div className={style.content}>
          <ExlyImage
            {...(item?.cover_image && {
              src: item?.cover_image,
            })}
            alt=""
            className={style.profilePic}
          />
          <div>
            <div className={style.name}>{item?.name || "Name"}</div>
            <div className={style.contentType}>
              {TESTIMONIAL_ICON_MAP[item?.type]()}
              &nbsp;
              {Object.entries(TESTIMONIAL_TYPES)
                .find((p) => p[1] === item?.type)[0]
                .toLocaleLowerCase()}
            </div>
          </div>
          <div
            className={classnames(
              style.optionsMenu,
              disableAllEdits && style.disabledBtn
            )}
            onClick={handleOpen}
          >
            <MoreVertIcon />
          </div>
          {children}
        </div>
        <div className={style.contentPreview}>
          {item?.type === TESTIMONIAL_TYPES.TEXT ? (
            <div className={style.previewTitle}>{item?.title}</div>
          ) : null}
          {item?.type === TESTIMONIAL_TYPES.TEXT ? (
            <div className={style.previewText}>
              {item?.content?.length > SHOW_CONTENT_LENGTH
                ? `${item?.content?.substring(0, SHOW_CONTENT_LENGTH)}...`
                : item?.content}
            </div>
          ) : null}
          {item?.type === TESTIMONIAL_TYPES.IMAGE ? (
            <div
              style={{
                backgroundImage: `url("${item?.media}")`,
              }}
              className={style.previewImage}
            />
          ) : null}
          {item?.type === TESTIMONIAL_TYPES.VIDEO ? (
            <ReactPlayer
              width="100%"
              height="100%"
              className={style.previewVideo}
              key={item?.media}
              url={parseYTUrl(item?.media)}
              controls
            />
          ) : null}
        </div>
      </div>
      <Menu
        id={`testimonial-menu-${item?.uuid}`}
        className={style.menuList}
        anchorEl={anchorEl}
        keepMounted
        open={!!anchorEl}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem
          onClick={() => {
            handleEdit();
            handleClose();
          }}
        >
          <EditIcon />
          &nbsp; Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleDelete();
            handleClose();
          }}
        >
          <DeleteIcon />
          &nbsp; Delete
        </MenuItem>
      </Menu>
    </div>
  );
};

const TestimonialList = React.memo(
  ({ stateProp = [], handleEdit, handleDelete, disableAllEdits }) =>
    (stateProp || []).map((item, index) => (
      <Draggable
        draggableId={item.uuid}
        index={index}
        key={item.uuid}
        mode="virtual"
      >
        {(draggableProvided, draggableSnapshot) => (
          <TestimonialItem
            key={item.uuid}
            item={item}
            handleEdit={handleEdit(item)}
            handleDelete={handleDelete(item)}
            isDragging={draggableSnapshot.isDragging}
            {...draggableProvided.draggableProps}
            innerRef={draggableProvided.innerRef}
            disableAllEdits={disableAllEdits}
          >
            <span
              className={style.dragHandle}
              {...draggableProvided.dragHandleProps}
              title="Drag and drop from here to reorder"
            >
              <DragIndicatorIcon />
            </span>
          </TestimonialItem>
        )}
      </Draggable>
    ))
);
TestimonialList.displayName = "TestimonialList";

TestimonialList.displayName = "TestimonialList";

export const Testimonials = (props) => {
  const {
    fetchCall,
    pushNotif,
    templateData,
    testimonials: { testimonialData, setTestimonialData },
    modal: { openModal, closeModal },
    miscellaneous_data,
    fetchMiscellaneousData,
    set_miscellaneous_data,
  } = useContext(WebpageCreationContext);

  const { setField, disableAllEdits } = props;

  const [state, setState] = useState(testimonialData || []);
  const [dragElement, setDragElement] = useState(null);
  const [isSaving, setSaving] = useState(null);
  const [errorObject, setErrorObject] = React.useState({});
  const [visible, set_visible] = React.useState(true);

  // Mutations for visibility toggle
  const { createMutation, updateMutation } = useVisibilityMutations();

  const reorder = (list, { from: startIndex, to: endIndex }) => {
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result.map((item, index) => ({
      ...item,
      priority: result.length - index - 1,
    }));
  };

  const handleDragStart = (result) => {
    setDragElement(result.draggableId);
    if (window.navigator.vibrate) {
      window.navigator.vibrate(100);
    }
  };

  const handleDragEnd = (result) => {
    setDragElement(null);
    if (
      !result?.destination ||
      result?.destination.index === result?.source.index
    ) {
      return;
    }

    const newState = reorder(state, {
      from: result.source.index,
      to: result.destination.index,
    });

    setState(newState);
    setTestimonialData(newState);
    handleReorder(newState);
  };

  const handleReorder = (stateProp) => {
    fetchCall({
      url: api.reorder_testimonial,
      method: "POST",
      payload: {
        testimonials: stateProp.map((item, index) => ({
          priority: stateProp.length - index - 1,
          uuid: item.uuid,
        })),
      },
      errorCallback: () => {
        pushNotif("Error while updating testimonial order");
      },
    });
  };

  const handleCreateReorder = (stateProp) => {
    if (!stateProp?.length) return;
    fetchCall({
      url: api.reorder_testimonial,
      method: "POST",
      payload: {
        testimonials: stateProp.map((item, index) => ({
          priority: stateProp.length - index,
          uuid: item.uuid,
        })),
      },
      errorCallback: () => {
        pushNotif("Error while updating testimonial order");
      },
    });
  };

  const handleCreate = () => {
    openModal(MODAL_TYPES.TESTIMONIALS, {
      modalLabels: {
        modalTitle: "Create New Testimonial",
        showDividers: true,
      },
      data: {
        type: TESTIMONIAL_TYPES.IMAGE,
        name: "",
        content: "", // Text, Image/Video Caption,
        media: "", // Image/Video URL
        cover_image: "", // Profile Pic
      },
      template: props.state.template.slug,
      primaryAction: ({ data: createData }) => {
        setSaving("Creating");
        closeModal();
        handleCreateReorder(testimonialData);
        fetchCall({
          url: api.create_testimonial,
          method: "POST",
          payload: {
            testimonial: {
              ...createData,
              priority: 0,
            },
          },
          successCallback: ({ uuid }) => {
            pushNotif("Testimonial created");
            setTestimonialData([
              ...testimonialData,
              { ...createData, uuid, priority: 0 },
            ]);
            setSaving(null);
          },
          errorCallback: (err) => {
            pushNotif(err?.body?.message || "Error while updating testimonial");
            setSaving(null);
          },
        });
      },
      secondaryAction: closeModal,
    });
  };

  const handleEdit = (item) => () => {
    openModal(MODAL_TYPES.TESTIMONIALS, {
      modalLabels: {
        modalTitle: "Edit Testimonial",
        showDividers: true,
      },
      data: item,
      template: props.state.template.slug,
      primaryAction: ({ data: updatedData }) => {
        setSaving("Updating");
        closeModal();
        fetchCall({
          url: api.update_testimonial,
          method: "POST",
          payload: {
            uuid: item.uuid,
            testimonial: {
              ...updatedData,
            },
          },
          successCallback: () => {
            pushNotif("Testimonial updated");
            setTestimonialData([
              ...testimonialData.map((t) =>
                t.uuid === item.uuid ? updatedData : t
              ),
            ]);
            setSaving(null);
          },
          errorCallback: (err) => {
            pushNotif(err?.body?.message || "Error while updating testimonial");
            setSaving(null);
          },
        });
      },
      secondaryAction: closeModal,
    });
  };

  const handleDelete = (item) => () => {
    openModal(MODAL_TYPES.CONFIRM, {
      modalLabels: {
        modalTitle: "Confirm Action",
        primaryText: "Cancel Delete",
        secondaryText: "Delete",
        showDividers: false,
      },
      body: `Are you sure you want to delete the testimonial given by ${item?.name}?`,
      hideCtaIcons: true,
      primaryAction: closeModal,
      secondaryAction: () => {
        setSaving("Deleting");
        closeModal();
        fetchCall({
          url: api.delete_testimonial,
          method: "POST",
          payload: {
            uuid: item.uuid,
          },
          successCallback: () => {
            pushNotif("Testimonial Deleted Successfully!");
            setState((stateProp) =>
              stateProp.filter((t) => t.uuid !== item.uuid)
            );
            setTestimonialData(
              testimonialData.filter((i) => i.uuid !== item.uuid)
            );
            setSaving(null);
          },
          errorCallback: (error) => {
            pushNotif(error?.body?.message || "Error while fetching user data");
            setSaving(null);
          },
        });
      },
    });
  };

  useEffect(() => {
    setState(testimonialData);
  }, [testimonialData]);

  useEffect(() => {
    if (!is_empty(errorObject)) setErrorObject({});
  }, [isSaving]);

  useEffect(() => {
    try {
      if (is_empty(miscellaneous_data?.testimonials)) {
        set_visible(true);
        return;
      }

      const temp = miscellaneous_data.testimonials[0];

      set_visible(
        typeof temp?.data?.visible === "boolean" ? temp.data.visible : true
      );
    } catch {
      set_visible(true);
    }
  }, [miscellaneous_data]);

  const onToggleVisibility = () =>
    handleVisibilityToggle({
      currentVisible: visible,
      setVisible: set_visible,
      miscellaneousData: miscellaneous_data,
      sectionKey: SECTIONKEY_TO_MISC_KEY[SIDEBAR_KEYS.TESTIMONIALS],
      sectionType: creator_miscellaneous_data_types.TESTIMONIALS,
      defaultSectionName: SIDEBAR_SECTIONS[SIDEBAR_KEYS.TESTIMONIALS].title,
      fetchMiscellaneousData,
      set_miscellaneous_data,
      createMutation: createMutation,
      updateMutation: updateMutation,
    });

  if (!testimonialData) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <SectionVisibilityToggle
        visible={visible}
        disabled={disableAllEdits}
        onToggle={onToggleVisibility}
      />

      <div className={baseStyle.fieldContainer}>
        <div className={baseStyle.label}>
          What would you like to call your Testimonials?
        </div>
        <div className={baseStyle.field}>
          <OutlinedInput
            placeholder="Enter the section heading here"
            className={baseStyle.input}
            rows={1}
            disabled={disableAllEdits}
            error={errorObject.sectionNameLength}
            value={props?.state?.custom_headings?.testimonials_title || ""}
            inputProps={{
              maxLength:
                TestimonialConfig?.maxTitleLength[props?.state?.template?.slug],
            }}
            onChange={(e) => {
              const value = e?.target?.value;
              if (
                value?.length >=
                TestimonialConfig?.maxTitleLength[props?.state?.template?.slug]
              ) {
                setErrorObject((prev) => ({
                  ...prev,
                  sectionNameLength: `Maximum field length of ${
                    TestimonialConfig?.maxTitleLength[
                      props?.state?.template?.slug
                    ]
                  } reached.`,
                }));
              } else {
                setErrorObject((prev) => ({
                  ...prev,
                  sectionNameLength: false,
                }));
              }
              setField("custom_headings", {
                ...props?.state?.custom_headings,
                testimonials_title: e?.target?.value || "",
              });
            }}
          />
        </div>
        {errorObject.sectionNameLength && (
          <div className={baseStyle.error}>
            {errorObject.sectionNameLength}
            <br />
            <br />
          </div>
        )}
        <TextFields
          slug_value={templateData.slug}
          Testimonials_config={TestimonialConfig}
          errorObject={errorObject}
          setErrorObject={setErrorObject}
          setField={setField}
          props={props}
        />
      </div>
      <div style={{ margin: "8px 0" }} className={baseStyle.info}>
        <InfoOutlined className={baseStyle.infoIcon} />
        The testimonial items can be dragged up and down using the
        <DragIndicatorIcon className={baseStyle.dragIcon} /> icon to change the
        order in which they appear.
      </div>

      <DragDropContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
        <Droppable droppableId="testimonialList">
          {(droppableProvided) => (
            <div
              className={`${style.testimonialContainer} ${
                dragElement ? style.dragHappening : ""
              }`}
              ref={droppableProvided.innerRef}
              {...droppableProvided.droppableProps}
            >
              <TestimonialList
                stateProp={state}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                disableAllEdits={disableAllEdits}
              />
              {droppableProvided.placeholder}
            </div>
          )}
        </Droppable>
        {isSaving ? (
          <div className={style.savingStatus}>
            {isSaving}&nbsp;
            <CircularProgress color="secondary" size={24} thickness={2} />
          </div>
        ) : null}
        <Button
          className={style.addButton}
          color="primary"
          disabled={isSaving || disableAllEdits}
          onClick={handleCreate}
        >
          <AddCircleIcon className={style.addIcon} /> Add testimonials
        </Button>
      </DragDropContext>
    </>
  );
};
